import { createContext } from 'react';

export type TicketCreationCtx = {
  showCreateTicketErrorAlert: boolean;
  showCreateTicketSuccessAlert: boolean;
  createTicketError: string;
};

const TicketContext = createContext<TicketCreationCtx>({
  showCreateTicketErrorAlert: false,
  showCreateTicketSuccessAlert: false,
  createTicketError: '',
});

export default TicketContext;
